// extracted by mini-css-extract-plugin
export default {"f":"_750ad827e2","main":"_9c854339f8","btn":"b4c0c11e4b","w":"f814616953","h":"bbfb1892c2","lh25":"b62ad902a4","wb":"_185be61480","b":"_5c6ae407b7","bx":"bc53c01819"};